'use strict';

import initBannersList from '../components/banners-list';
import initCarousel from '../components/carousel';

document.addEventListener('DOMContentLoaded', function () {
  initBannersList();
  initCarousel();
});
